
const panelMarkup = '<div class="suggestPanel" id="searchSuggestBox"></div>';

function setupSuggestionPanel() {
    const suggestionTarget = document.querySelector('.s1-searchsuggest');

    if(suggestionTarget) {
        suggestionTarget.insertAdjacentHTML('afterend', panelMarkup);
    }

}

function setupSystem1GlobalUtils() {
    if(!window.isIE11) window.isIE11 = document.querySelector('html').closest === undefined;

    if(!window.debounce) 
        window.debounce = (func, wait, immediate) => {
            let timeout;
            return (...args) => {
                const context = this
                const later = () => {
                    timeout = null;
                    if (!immediate) func.apply(context, args);
                };
                const callNow = immediate && !timeout;
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
                if (callNow) func.apply(context, args);
            };
        };
}

function setup_suggester() {
    setupSuggestionPanel();
    setupSystem1GlobalUtils();
    new window.Suggester(document.querySelector('#q'));
}


if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => setup_suggester());
} else {
    setup_suggester();
}

